export const category = [
    {
        image: 'https://images.unsplash.com/photo-1536599018102-9f803c140fc1?auto=format&fit=crop&w=440&h=220&q=60',
        title: 'Background',
        description: 'Download free desktop and mobile backgrounds.',
        links: [
            'Cool Backgrounds',
            'Desktop Backgrounds'
        ]
    },
    {
        image: 'https://images.unsplash.com/photo-1448387473223-5c37445527e7?auto=format&fit=crop&w=440&h=220&q=60',
        title: 'Images',
        description: 'Download amazing photos and pictures for free.',
        links: ['Free Stock Photos', 'Nature Images']
    },
    {
        image: 'https://images.unsplash.com/photo-1502759683299-cdcd6974244f?auto=format&fit=crop&w=440&h=220&q=60',
        title: 'Wallpapers',
        description: 'Discover your next desktop or mobile wallpaper.',
        links: [
            'IPhone Wallpapers',
            'Cool Wallpapers'
        ]
    },
]
